export default __webpack_public_path__ + "static/mean-cycle-2-d-0bde8070d650e730951cb1d8883298f9.svg";